<template>
    <span>
    <div  class="ml-10 mr-10 mt-10" v-html="data.print_content"></div>
    <div class="hide-on-print pull-right">
        <v-btn color="primary" large dressed @click="print" class="hide-on-xs mr-2">Print</v-btn>
        <v-btn color="secondary" large dressed @click="pdfDownload"
               class="mr-2">Download as pdf
        </v-btn>
        <v-btn color="secondary" large dressed @click="moveToApplyAgain"
               class="mr-2">Apply again
        </v-btn>
    </div>
    </span>
</template>

<script>
    export default {
        name: "CertificationPrint",
        props: ['data'],
        methods: {
            print(){
              window.print()
            },
            pdfDownload() {
                window.open(this.data.pdf_url, "_blank");

            },
            moveToApplyAgain() {
                window.location.reload();
            }
        }
    }
</script>
